import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ToggleGruppe } from "./..";
export const _frontmatter = {
  "ingress": "ToggleGruppe er en samling av flere <a href=\"/components/toggleknapp\">ToggleKnapper</a>. ToggleGruppe tar seg også av styling av ToggleKnapper slik at disse står helt inntil hverandre."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#multiselect"
          }}>{`MultiSelect`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#minst-én"
          }}>{`Minst én`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kompakt"
          }}>{`Kompakt`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <p>{`I default varianten kan man bare aktivere èn ToggleKnapp om gangen.`}</p>
    <Example mdxType="Example">
  <ToggleGruppe defaultToggles={[{
        children: "Mandag",
        pressed: true
      }, {
        children: "Tirsdag"
      }, {
        children: "Onsdag"
      }]} mdxType="ToggleGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<ToggleGruppe
  defaultToggles={[
    { children: "Mandag", pressed: true },
    { children: "Tirsdag" },
    { children: "Onsdag" },
  ]}
/>
`}</code></pre>
    <h2 {...{
      "id": "multiselect"
    }}>{`MultiSelect`}</h2>
    <p>{`For å tillate flere aktive ToggleKnapper samtidig kan man bruke `}<inlineCode parentName="p">{`multiSelect`}</inlineCode>{` propen.`}</p>
    <Example mdxType="Example">
  <ToggleGruppe defaultToggles={[{
        children: "Mandag",
        pressed: true
      }, {
        children: "Tirsdag"
      }, {
        children: "Onsdag"
      }]} multiSelect mdxType="ToggleGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<ToggleGruppe
  defaultToggles={[
    { children: "Mandag", pressed: true },
    { children: "Tirsdag" },
    { children: "Onsdag" },
  ]}
  multiSelect
/>
`}</code></pre>
    <h2 {...{
      "id": "minst-én"
    }}>{`Minst én`}</h2>
    <p>{`Bruk `}<inlineCode parentName="p">{`minstEn`}</inlineCode>{` propen for å håndheve at det alltid må være èn ToggleKnapp som er valgt.`}</p>
    <Example mdxType="Example">
  <ToggleGruppe defaultToggles={[{
        children: "Mandag"
      }, {
        children: "Tirsdag"
      }, {
        children: "Onsdag"
      }]} minstEn mdxType="ToggleGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<ToggleGruppe
  defaultToggles={[
    { children: "Mandag" },
    { children: "Tirsdag" },
    { children: "Onsdag" },
  ]}
  minstEn
/>
`}</code></pre>
    <h2 {...{
      "id": "kompakt"
    }}>{`Kompakt`}</h2>
    <p>{`ToggleGruppe støtter også en `}<inlineCode parentName="p">{`kompakt`}</inlineCode>{` variant som kan passe bra hvis ToggleKnappene har lite tekstinnhold eller bare ikoner.`}</p>
    <Example mdxType="Example">
  <ToggleGruppe defaultToggles={[{
        children: "B",
        pressed: true
      }, {
        children: <em style={{
          paddingLeft: 2,
          paddingRight: 2
        }}>I</em>
      }, {
        children: <span style={{
          textDecoration: "underline"
        }}>U</span>
      }]} multiSelect kompakt mdxType="ToggleGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<ToggleGruppe
  defaultToggles={[
    { children: "B", pressed: true },
    { children: <em style={{ paddingLeft: 2, paddingRight: 2 }}>I</em> },
    { children: <span style={{ textDecoration: "underline" }}>U</span> },
  ]}
  multiSelect
  kompakt
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      